'use strict';

/* eslint no-undef: "off" */
/**
 * XPark FAQ
 */
define('xparkFaq',['xparkHomepageApi'], function (xparkHomepageApi) {
  return {
    template: '\n      <section class="xp-faq" v-if="faqList.length">\n        <h2>FAQ</h2>\n\n        <div class="xp-faq-list">\n          <div\n            v-for="(item, index) in faqList"\n            :key="item.title"\n            class="xp-faq-item"\n            :class="{\n              \'is-active\': activeIndex === index,\n              \'is-expanded\': isFaqExpanded(index)\n            }"\n          >\n            <button\n              class="xp-faq-question"\n              type="button"\n              :aria-expanded="activeIndex === index ? \'true\' : \'false\'"\n              @click="toggleFaq(index)"\n            >\n              <span v-text="item.title"></span>\n              <i aria-hidden="true"></i>\n            </button>\n\n            <div\n              :ref="\'faqMeasure-\' + index"\n              class="xp-faq-answer xp-faq-answer--measure"\n              v-html="item.content"\n            ></div>\n\n            <div\n              v-if="activeIndex === index"\n              class="xp-faq-answer"\n              :class="{\n                \'is-collapsed\': faqHasMore(index) && !isFaqExpanded(index)\n              }"\n              v-html="item.content"\n            ></div>\n\n            <button\n              v-if="activeIndex === index && faqHasMore(index)"\n              class="xp-faq-more"\n              type="button"\n              @click.stop="toggleFaqContent(index)"\n              v-text="isFaqExpanded(index) ? \'Show Less\' : \'Show More\'"\n            ></button>\n          </div>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        activeIndex: -1,
        faqList: [],
        faqMoreStates: [],
        faqExpandedStates: []
      };
    },
    mounted: function mounted() {
      this.fetchFaqItems();
    },

    methods: {
      fetchFaqItems: function fetchFaqItems() {
        var _this = this;

        xparkHomepageApi.getFaqItems().then(function (data) {
          if (!Array.isArray(data) || !data.length) {
            return;
          }

          _this.faqList = data.map(function (item) {
            return {
              title: item.title || '',
              content: item.content || ''
            };
          }).filter(function (item) {
            return item.title && item.content;
          });
          _this.faqMoreStates = _this.faqList.map(function () {
            return false;
          });
          _this.faqExpandedStates = _this.faqList.map(function () {
            return false;
          });

          _this.$nextTick(function () {
            _this.updateFaqMoreStates();
          });
        }).catch(function () {});
      },
      toggleFaq: function toggleFaq(index) {
        var _this2 = this;

        this.activeIndex = this.activeIndex === index ? -1 : index;

        if (this.activeIndex === index) {
          this.$nextTick(function () {
            _this2.updateFaqMoreState(index);
          });
        }
      },
      toggleFaqContent: function toggleFaqContent(index) {
        if (!this.faqHasMore(index)) {
          return;
        }
        this.$set(this.faqExpandedStates, index, !this.isFaqExpanded(index));
      },
      faqHasMore: function faqHasMore(index) {
        return !!this.faqMoreStates[index];
      },
      isFaqExpanded: function isFaqExpanded(index) {
        return !!this.faqExpandedStates[index];
      },
      updateFaqMoreStates: function updateFaqMoreStates() {
        var _this3 = this;

        this.faqList.forEach(function (_, index) {
          _this3.updateFaqMoreState(index);
        });
      },
      updateFaqMoreState: function updateFaqMoreState(index) {
        var ref = this.$refs['faqMeasure-' + index];
        var answerEl = Array.isArray(ref) ? ref[0] : ref;

        if (!answerEl) {
          return;
        }

        var lineHeight = parseFloat(window.getComputedStyle(answerEl).lineHeight) || 0;
        if (!lineHeight) {
          return;
        }

        var maxHeight = lineHeight * 4;
        var hasMore = answerEl.scrollHeight > maxHeight + 1;
        this.$set(this.faqMoreStates, index, hasMore);
      }
    }
  };
});
